import type { useAuth0 } from '@auth0/auth0-react';
import { setAuthContextOnBackendService } from 'BackendAuthHandler';
import { useEffect } from 'react';

/**
 * Shared components such as AssetImage load stored images through BackendService, which takes
 * its token from this sign-in, as the admin portal's CheckLoginComponent sets it.
 */
export function useBackendServiceSignIn(auth0: ReturnType<typeof useAuth0>) {
  const { isAuthenticated } = auth0;
  useEffect(() => {
    if (isAuthenticated) setAuthContextOnBackendService(auth0);
  }, [isAuthenticated, auth0]);
}
